import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { ICreateGroup, IGetGroupFilters, IGroup, IUpdateGroup } from '../../../../pages/management/services/service-groups/interface/groups.interface';

@Injectable({
  providedIn: 'root',
})
export class ServiceGroupsService {
  constructor(private readonly apiService: ApiService) {}

  create(data: ICreateGroup) {
    return this.apiService.post<IGroup>('service-groups/create', data);
  }
  update(data: IUpdateGroup) {
    return this.apiService.patch<IGroup>(
      'service-groups/update',
      data
    );
  }
  delete(id: number) {
    return this.apiService.delete<{success:boolean}>(
      `service-groups/delete/${id}`,
    );
  }
  getAll(data: IGetGroupFilters) {
    return this.apiService.post<IGroup[]>(
      'service-groups/getAll',
      data
    );
  }
}
